import { type AxiosResponse } from 'axios';
import { apiUri } from '@/constants/Constants';
import userValues from '@/utils/normalizeUser';
import { client, modernClient } from '@/shared/api';
import type { UserResponse } from '@/utils/types/User';

import { mapModernGetMeToUser } from './map-modern-get-me-to-user';
import type { ModernGetMeResponse } from './modern-get-me.types';

export const getUser = async (useModernMe = false) => {
  if (useModernMe) {
    const { data } = await modernClient.get<ModernGetMeResponse>(apiUri.getMe);
    return mapModernGetMeToUser(data);
  }

  const resp: AxiosResponse<UserResponse> = await client.get(apiUri.getMe, {
    withCredentials: true,
  });

  return userValues(resp);
};

export default getUser;
